import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        const input = this.element.querySelector("[autofocus]");
        if (input) {
            setTimeout(() => input.focus(), 200);
        }
    }
}
